const TwoPasswordsValidator = (firstPasswordValue: string, secondPasswordValue: string | undefined): ITwoPasswordsValidatorResult => {
    if (!secondPasswordValue || !secondPasswordValue.trim()) return { passed: false, error: "Confirm your password" };
    if (firstPasswordValue !== secondPasswordValue) return { passed: false, error: "The passwords don’t match. Try again." };
    return { passed: true };
};

interface ITwoPasswordsValidatorResult {
    passed?: boolean;
    error?: PasswordValidatorError;
}

type PasswordValidatorError = "Confirm your password" | "The passwords don’t match. Try again.";

export default TwoPasswordsValidator;
export type { ITwoPasswordsValidatorResult };
